import React from "react";
import RecipientsTable from "components/Tables/RecipientsTable.js";

export const Recipients = ({ emailCampaign, style = {} }) => {
  return (
    <div style={{ flexDirection: "column", flexGrow: 1, flexShrink: 0, width: "100%", ...style }}>
      <RecipientsTable emailCampaign={emailCampaign} />
    </div>
  );
};

export default Recipients;
